export const flattenProgramTree = (programs, level = 0) => {
  let result = [];

  programs.forEach((program) => {
    result.push({
      value: program.id,
      label: `${"— ".repeat(level)}${program.name}`,
    });

    if (program.children && program.children.length > 0) {
      result = result.concat(flattenProgramTree(program.children, level + 1));
    }
  });

  return result;
};
